import { useState, useCallback } from 'react';
import { getQueryStringValue, setQueryStringValue } from '../queryString';
import { isNumericString } from '../helpers/strings';

function useQueryString(key, initialValue) {
  const [value, setValue] = useState(getQueryStringValue(key) || initialValue);
  // options is read defensively: these setters are widely passed straight to
  // component callbacks, which may hand us a second argument of their own
  const onSetValue = useCallback(
    (newValue, options) => {
      setValue(newValue);
      setQueryStringValue(key, newValue, window.location.search, {
        shouldReplace: options?.shouldReplace === true,
      });
    },
    [key],
  );

  const parsedValue =
    value === 'false' || value === 'true' || isNumericString(value)
      ? JSON.parse(value)
      : value;

  return [parsedValue, onSetValue];
}

export default useQueryString;
